import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  
  
  
} from '@angular/core';



import type { CustomMiniBasketContentComponent as OriginalComponent } from 'ish-shared/dias/components/custom-mini-basket-content/custom-mini-basket-content.component';

@Component({
  selector: 'custom-lazy-mini-basket-content',
  standalone: false,
  templateUrl: './lazy-custom-mini-basket-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyCustomMiniBasketContentComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component shared/dias/components/custom-mini-basket-content/custom-mini-basket-content.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;



  private component: ComponentRef<OriginalComponent>;
  

  constructor(
    
    private injector: Injector
  ) {}

  async ngOnInit() {
    

      await this.renderComponent();

    
  }

  private async renderComponent() {
    const module = await import(`../../../shared/shared.module`).then(m => m.SharedModule);

    const { CustomMiniBasketContentComponent: originalComponent } = await import('ish-shared/dias/components/custom-mini-basket-content/custom-mini-basket-content.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.component.changeDetectorRef.markForCheck();
  }


}
